/* src/app/views/template/components/templates/web/web-product-templates/web-product-templates.component.scss */
/*# sourceMappingURL=web-product-templates.component.css.map */
